<template>
  <main class="wrapper-content">
    <template v-if="!isLoading">
      <h1>{{ header }}</h1>
      <b-row>
        <LmTextInput
          class=" col-md-6 col-12"
          placeholder="Nombre"
          label="Nombre"
          v-model="$v.name.$model"
          :v="v('name')"
        />
        <LmTextInput
          class=" col-md-6 col-12"
          placeholder="Código"
          label="Código"
          v-model="$v.codename.$model"
          :v="v('codename')"
        />
        <LmTextArea
          class="col-12"
          placeholder="Descripción"
          label="Descripción"
          v-model="$v.description.$model"
          :v="v('description')"
        />
        <LmButton
          class="col-auto"
          buttonClass="btn-secondary"
          :value="$t('cancel')"
          @click="onCancel"
        />
        <LmButton
          class="col-auto"
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
        />
        <LmButton
          class="col-auto"
          action="delete"
          buttonClass="btn-danger"
          :value="$t('delete')"
          v-if="isOnEditMode"
          @click="onDelete"
        />
      </b-row>
    </template>
    <!-- loading state -->
    <template class="mt-4" v-else>
      <b-row>
        <b-col cols="12" class="my-4"><b-skeleton width="30%"></b-skeleton></b-col>
        <b-col><b-skeleton type="input"></b-skeleton></b-col>
        <b-col><b-skeleton type="input"></b-skeleton></b-col>
        <b-col cols="12" class="mt-4"><b-skeleton height="120px" type="input"></b-skeleton></b-col>
      </b-row>
      <div class="d-flex mt-4" style="gap: 1rem">
        <b-skeleton type="button"></b-skeleton>
        <b-skeleton type="button"></b-skeleton>
        <b-skeleton type="button"></b-skeleton>
      </div>
    </template>
  </main>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmTextInput,
    LmTextArea,
    LmButton
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      name: '',
      codename: '',
      description: ''
    }
  },
  computed: {
    header () {
      return this.isOnEditMode ? `Editar ${this.name}` : 'Nuevo Privilegio'
    }
  },
  validations: {
    name: { required },
    codename: { required },
    description: { required }
  },
  methods: {
    v (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSubmit () {
      try {
        await this.validateForm(this.$v)
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`/privileges/${this.$route.params.id}`, {
            name: this.name,
            codename: this.codename,
            description: this.description
          })
        } else {
          const res = await commonsApi.axiosPostWrapper('/privileges', {
            name: this.name,
            codename: this.codename,
            description: this.description
          })
          this.$router.replace(`/privilegios/editar/${res.data._id}`)
        }
        this.lmToastSuccessMessage(
          `Se guardó correctamente el rol ${this.name}`,
          'Acción realizada con éxito'
        )
      } catch (error) {
        console.log(error)
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onDelete () {
      try {
        await commonsApi.axiosDeleteWrapper(`/privileges/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `Se eliminó correctamente el rol ${this.name}`,
          'Acción realizada con éxito'
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      }
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/privileges/${this.$route.params.id}`)
      this.name = res.data.name
      this.codename = res.data.codename
      this.description = res.data.description
    }
  },
  watch: {
    name (val) {
      if (!this.isOnEditMode) {
        this.codename = val.toUpperCase().replace(/\s/g, '')
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
